import { useState, useEffect, useMemo } from "react";
import MathText from "../VueQuestion/MathText";
import SeparateurRubrique from "../general/SeparateurRubrique";
import { partitionnerParRubrique } from "../../utils/rubriqueAttendus";
import { tronquerTexteMaths } from "../../utils/tronquerTexteMaths";
import { renderTextWithLineBreaks } from "../../utils/DeleteBr";
import { ChevronDown ,ChevronLeft, ChevronRight, Search, X } from 'lucide-react';
import React from "react";

// Les niveaux du petit menu « Niveau » (chiffres de themes/?niveau=).
const NIVEAUX = ['6', '5', '4', '3'];

// Composant NotificationOption
const NotificationOption = ({ label, onChange, checked }) => {
  const renderTextWithLineBreaks = (text) => {
  if (!text) return '';
  return text.split('<br>').map((line, index, array) => (
    <React.Fragment key={index}>
      <MathText>{line}</MathText>
      {index < array.length - 1 && <br />}
    </React.Fragment>
  ));
};

  return (
   <div className={`rounded-xl transition-all duration-300 ${
     checked 
       ? 'bg-gradient-to-r from-green-50 to-emerald-50' 
       : 'bg-gradient-to-r from-gray-50 to-slate-50'
   }`}>
    <div 
      onClick={onChange}  // ← AJOUT DE CETTE LIGNE
      className={`flex items-center gap-4 xl:gap-2 2xl:gap-3 3xl:gap-4 p-4 xl:p-2 2xl:p-3 3xl:p-4 border-2 rounded-xl
     cursor-pointer transition-all duration-300 relative overflow-hidden 
     group hover:border-green-400 hover:bg-green-50 hover:transform hover:translate-x-2 ${
       checked 
         ? 'border-green-400 bg-gradient-to-r from-green-50 to-emerald-50 shadow-md' 
         : 'border-gray-200'
     }`}>
      <div className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b
       from-teal-500 to-green-500 transform scale-y-0
        group-hover:scale-y-100 transition-transform duration-300"></div>
      
      <div className="flex-1">
        <span className={`font-medium leading-relaxed xl:text-base text-xs ${
          checked ? 'text-green-700' : 'text-gray-700'
        }`}>
          {renderTextWithLineBreaks(label)}
        </span>
      </div>
      
      <div className={`
        w-6 h-6 border-2 rounded-lg flex items-center justify-center transition-all duration-300
        ${checked
          ? 'bg-green-500 border-green-500 text-white transform scale-110'
          : 'border-gray-300 bg-white'
        }
      `}>
        {checked && (
          <span className="text-sm font-bold">✓</span>
        )}
      </div>
    </div>
    </div>
  );
};


/**
 * AUTRE NIVEAU (2026-09-29, demande de deux profs : évaluer une 4e sur un
 * objectif de 6e ; rare, donc discret) : avec `onChangeNiveau`, un petit menu
 * « Niveau » à côté du thème, réglé sur la classe (`niveauClasse`). Le parent
 * charge l'arbre du niveau choisi (`niveauAttendus`) ; `chargementNiveau` tant
 * qu'il n'est pas arrivé. Absent en devoir commun.
 */
function InfoSavoirs ({ThemeDetail, handleDescripteurChange,handleThemeChange,selectedTheme, descripteurs, selectedDescripteur,
   handleNext , handlePrev, savoirs , selectedSavoirs ,
     handleSavoirChange ,attendus, handleAttenduChange, selectedAttendus,
     niveauClasse = '', niveauAttendus = '', onChangeNiveau, chargementNiveau = false}) {
// Détection automatique si des savoirs_faires existent dans les descripteurs
  const [hasSavoirsFaires, setHasSavoirsFaires] = useState(false);
 const [typeSavoir, setTypeSavoir] = useState('attendus')
 const [showSavoirsForDescripteur, setShowSavoirsForDescripteur] = useState(false);
const [expandedDescripteurs, setExpandedDescripteurs] = useState('');
// Sections Objectifs/Automatismes : repliables comme le panel des attendus
// (choix explicite prime ; défaut FERMÉ, sauf si la section contient un
// attendu déjà coché). Clé : `${descripteur}::objs` / `::autos`.
const [choixSections, setChoixSections] = useState({});
const toggleSection = (cle, ouvertActuel) =>
  setChoixSections(prev => ({ ...prev, [cle]: !ouvertActuel }));
const [searchTerm, setSearchTerm] = useState('');

// Recherche dans TOUS les descripteurs (pas seulement le selectedDescripteur)
const searchResults = useMemo(() => {
  if (!searchTerm.trim() || !descripteurs) return null;

  const query = searchTerm.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  const results = { savoirs: [], attendus: [] };

  descripteurs.forEach(desc => {
    // Chercher dans les savoirs_faires de chaque descripteur
    (desc.savoirs_faires || []).forEach(s => {
      if ((s.nom || '').toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").includes(query)) {
        results.savoirs.push({ ...s, descripteurNom: desc.nom });
      }
    });

    // Chercher dans les attendus de chaque descripteur
    (desc.attendus || []).forEach(a => {
      if ((a.description || '').toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").includes(query)) {
        results.attendus.push({ ...a, descripteurNom: desc.nom });
      }
    });
  });

  return results;
}, [descripteurs, searchTerm]);

 // Vérification automatique de la présence de savoirs_faires
  useEffect(() => {
    if (descripteurs && descripteurs.length > 0) {
      // Vérifie si au moins un descripteur a des savoirs_faires non vides
      const hasSavoirs = descripteurs.some(desc => 
        desc.savoirs_faires && desc.savoirs_faires.length > 0
      );
      setHasSavoirsFaires(hasSavoirs);
      
      // Si pas de savoirs_faires, force le type sur 'attendus'
      if (!hasSavoirs) {
        setTypeSavoir('attendus');
      }
    }
  }, [descripteurs]);

 const handleTypeSavoirChange = (e) => {
    setTypeSavoir(e);
    setSearchTerm(''); // Reset la recherche
}
const handleDescripteurClick = (item) => {
    if (expandedDescripteurs === item) {
        // Si on clique sur le même descripteur, on ferme
        setExpandedDescripteurs('');
        setShowSavoirsForDescripteur(false);
    } else {
        // Si on clique sur un autre descripteur, on l'ouvre
        setExpandedDescripteurs(item);
        setShowSavoirsForDescripteur(true);  // ← TOUJOURS true quand on ouvre
    }
    handleDescripteurChange(item);
}


const handleLocalThemeChange = (item) => {
    setShowSavoirsForDescripteur(false);
    setSearchTerm(''); // Reset la recherche
    handleThemeChange(item)
}

// Changer de niveau repart du choix du thème (le parent vide thème et chapitre).
const handleLocalNiveauChange = (n) => {
    setShowSavoirsForDescripteur(false);
    setExpandedDescripteurs('');
    setSearchTerm('');
    onChangeNiveau(n);
}

    return(
        <div className="w-full
         max-w-6xl mx-auto bg-white/95 backdrop-blur-xl 
         rounded-3xl shadow-2xl overflow-hidden border
          border-white/20">

               {/* Header */}
      <div className="bg-gradient-to-r from-blue-500 to-sky-600 text-white text-center py-8 xl:py-4 2xl:py-5 3xl:py-8 px-10 xl:px-5 2xl:px-7 3xl:px-10
      relative overflow-hidden">
        <div className="absolute -top-16 -right-16 w-32 h-32 bg-white/10 rounded-full"></div>
        <h1 className="text-3xl xl:text-lg 2xl:text-xl 3xl:text-3xl font-bold mb-2 relative z-10">   Savoirs-faires</h1>
        <p className="text-lg xl:text-xs 2xl:text-sm 3xl:text-lg opacity-90 relative z-10">
           Personnalisez les critères pédagogiques d'évaluations</p>
      </div>
 
    <div className="flex sm:flex-col xl:text-sm 2xl:text-sm 3xl:text-2xl lg:text-base
     text-sm lg:flex-col gap-8 xl:gap-4 2xl:gap-5 3xl:gap-8 p-6 xl:p-3 2xl:p-4 3xl:p-6">
     
        <div className="w-full ">
   
       
    
          {/* Formulaire de sélection du thème */}
          <div className=" mx-auto">
            <div className="">
              <div className="flex items-center justify-between gap-3 mb-6 xl:mb-3 2xl:mb-4 3xl:mb-6">
              <label className="flex items-center gap-3 text-xl xl:text-sm 2xl:text-base 3xl:text-xl font-bold text-gray-800">
                <div className="w-8 h-8 xl:w-6 xl:h-6 2xl:w-7 2xl:h-7 3xl:w-8 3xl:h-8 rounded-xl bg-gradient-to-r from-blue-500 to-sky-500
                flex items-center justify-center">
                  <span className="text-white text-lg xl:text-xs 2xl:text-sm 3xl:text-lg">🎨</span>
                </div>
                Thème
              </label>
              {/* Autre niveau : discret, réglé sur la classe. */}
              {onChangeNiveau ? (
                <div className="flex items-center gap-2 text-xs font-semibold text-slate-500">
                  Niveau
                  <select
                    aria-label="Niveau des attendus"
                    value={niveauAttendus}
                    onChange={(e) => handleLocalNiveauChange(e.target.value)}
                    className="text-[12px] font-bold text-slate-600 bg-white border border-slate-200 rounded-lg px-1.5 py-1 outline-none focus:border-blue-400"
                  >
                    {NIVEAUX.map((n) => (
                      <option key={n} value={n}>{n}e{n === niveauClasse ? ' (classe)' : ''}</option>
                    ))}
                  </select>
                </div>
              ) : null}
              </div>

              <div className="relative group">
                <select
                  value={selectedTheme}
                  onChange={(e)=> handleLocalThemeChange(e.target.value)}
                  disabled={chargementNiveau}
                  className={`
                    w-full p-4 xl:p-2 2xl:p-3 3xl:p-4 pr-14 border-2 rounded-2xl text-lg xl:text-xs 2xl:text-sm 3xl:text-lg font-medium transition-all duration-300 appearance-none cursor-pointer
                    ${selectedTheme 
                      ? 'border-green-400 bg-gradient-to-r from-green-50 to-emerald-50' 
                      : 'border-gray-200 bg-gradient-to-r from-gray-50 to-slate-50 hover:border-gray-300 hover:bg-white'
                    }
                    focus:outline-none focus:border-indigo-500 focus:shadow-lg focus:scale-102
                  `}
                >
                  <option value="">{chargementNiveau ? 'Chargement des thèmes…' : 'Choisir un thème'}</option>
                  {ThemeDetail.map(theme => (
                    <option key={theme.id} value={theme.nom}>
                      {theme.nom}
                    </option>
                  ))}
                </select>
                
                <ChevronDown className={`
                  absolute right-5 top-1/2 transform
                   -translate-y-1/2 w-6 h-6 transition-all duration-300 pointer-events-none
                  ${selectedTheme ? 'text-green-500' : 'text-gray-400 group-hover:text-indigo-500'}
                `} />
              </div>
              </div></div>        
     
      </div>
   
   
</div>
 {/* Boutons Type (Bulletin/Attendus) */}
{selectedTheme && 
<>
 <div className="mb-8 xl:mb-4 2xl:mb-6 3xl:mb-8 animate-fadeInUp px-6 xl:px-3 2xl:px-4 3xl:px-6">
<div className="flex gap-4 xl:gap-2 2xl:gap-3 3xl:gap-4 mb-6 xl:mb-3 2xl:mb-4 3xl:mb-6">
{hasSavoirsFaires && (
<div  className={`
                    flex-1 p-6 xl:p-3 2xl:p-4 3xl:p-6 border-2 rounded-2xl font-semibold text-lg xl:text-xs 2xl:text-sm 3xl:text-lg 
                    transition-all duration-300 relative overflow-hidden
                    ${typeSavoir === 'bulletin_de_rentrée' 
                      ? 'border-sky-400 bg-gradient-to-r from-blue-500 to-sky-600 text-white shadow-lg transform -translate-y-1' 
                      : 'border-blue-400 bg-white text-blue-600 hover:bg-sky-50 hover:shadow-md'
                    }
                  `}
    onClick={()=> handleTypeSavoirChange("bulletin_de_rentrée")}>
      <span className="relative z-10">📋 BULLETIN DE RENTRÉE</span>
      {typeSavoir === 'bulletin_de_rentrée' && (
                    <div className="absolute top-0 right-0 w-16 h-16 bg-white/10 rounded-full -translate-y-8 translate-x-8"></div>
                  )}
    </div>
)}

    <div  className={`
        ${(!hasSavoirsFaires) ? 'w-full' : 'flex-1'}
        p-6 xl:p-3 2xl:p-4 3xl:p-6 border-2 rounded-2xl font-semibold text-lg xl:text-xs 2xl:text-sm 3xl:text-lg transition-all duration-300 relative overflow-hidden
        ${typeSavoir === 'attendus' 
          ? 'border-sky-400 bg-gradient-to-r from-blue-500 to-sky-600 text-white shadow-lg transform -translate-y-1' 
          : 'border-blue-400 bg-white text-blue-600 hover:bg-sky-50 hover:shadow-md'
        }
      `}    onClick={()=> handleTypeSavoirChange("attendus")}>
 <span className="relative z-10">🎯 {!hasSavoirsFaires ? "OBJECTIFS D'APPRENTISSAGE" : "LES ATTENDUS"}</span>
                  {typeSavoir === 'attendus' && (
                    <div className="absolute top-0 right-0 w-16 h-16 bg-white/10 rounded-full -translate-y-8 translate-x-8"></div>
                  )}
               
</div>

</div>

{/* Search Input - visible dès qu'un thème est sélectionné */}
<div className="relative mb-6">
  <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
    <Search className="w-5 h-5 text-gray-400" />
  </div>
  <input
    type="text"
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
    placeholder={typeSavoir === 'attendus' ? "Rechercher un attendu..." : "Rechercher un savoir..."}
    className="w-full pl-12 pr-10 py-3 border-2 border-gray-200 rounded-xl
      text-sm transition-all duration-300
      focus:border-blue-400 focus:outline-none focus:shadow-md
      hover:border-gray-300 bg-gradient-to-r from-gray-50 to-slate-50"
  />
  {searchTerm && (
    <button
      onClick={() => setSearchTerm('')}
      className="absolute inset-y-0 right-0 pr-4 flex items-center
        text-gray-400 hover:text-gray-600 transition-colors"
    >
      <X className="w-5 h-5" />
    </button>
  )}
</div>
</div>
<div className="space-y-4">
 {/* Résultats de recherche OU Liste des descripteurs */}
{typeSavoir && (
  <div className="mb-8 animate-fadeInUp pl-6 pr-6">

    {/* Si recherche active : afficher les résultats directement */}
    {searchResults ? (
      <>
        <h3 className="text-xl xl:text-sm 2xl:text-base 3xl:text-xl font-bold text-gray-800 mb-6 xl:mb-3 2xl:mb-4 3xl:mb-6 flex items-center gap-3">
          <div className="w-8 h-8 xl:w-6 xl:h-6 2xl:w-7 2xl:h-7 3xl:w-8 3xl:h-8 rounded-xl bg-gradient-to-r from-blue-500 to-sky-500 flex items-center justify-center">
            <Search className="w-4 h-4 text-white" />
          </div>
          Résultats de recherche
        </h3>
        <div className="space-y-3">
          {typeSavoir === 'bulletin_de_rentrée' && (
            searchResults.savoirs.length > 0 ? (
              searchResults.savoirs.map((savoir) => (
                <div key={savoir.id} className="xl:text-sm text-xs animate-fadeInUp">
                  <span className="inline-block mb-1 ml-2 px-2 py-0.5 bg-blue-100 text-blue-600 text-[10px] rounded-full">
                    {savoir.descripteurNom}
                  </span>
                  <NotificationOption
                    label={savoir.nom}
                    onChange={() => handleSavoirChange(savoir)}
                    checked={selectedSavoirs?.some((s) => s.id === savoir.id)}
                  />
                </div>
              ))
            ) : (
              <div className="text-center py-8 text-gray-500">
                <Search className="w-10 h-10 mx-auto mb-3 opacity-40" />
                <p className="font-medium">Aucun savoir trouvé pour "{searchTerm}"</p>
                <p className="text-sm mt-1">Essayez un autre terme de recherche</p>
              </div>
            )
          )}

          {typeSavoir === 'attendus' && (
            searchResults.attendus.length > 0 ? (
              searchResults.attendus.map((attendu) => (
                <div key={attendu.id} className="xl:text-sm text-xs animate-fadeInUp">
                  <span className="inline-block mb-1 ml-2 px-2 py-0.5 bg-emerald-100 text-emerald-600 text-[10px] rounded-full">
                    {attendu.descripteurNom}
                  </span>
                  <NotificationOption
                    label={attendu.description}
                    onChange={() => handleAttenduChange(attendu)}
                    checked={selectedAttendus?.some((a) => a.id === attendu.id)}
                  />
                </div>
              ))
            ) : (
              <div className="text-center py-8 text-gray-500">
                <Search className="w-10 h-10 mx-auto mb-3 opacity-40" />
                <p className="font-medium">Aucun attendu trouvé pour "{searchTerm}"</p>
                <p className="text-sm mt-1">Essayez un autre terme de recherche</p>
              </div>
            )
          )}
        </div>
      </>
    ) : (
      /* Si pas de recherche : afficher les descripteurs collapsibles */
      <>
        <h3 className="text-xl xl:text-sm 2xl:text-base 3xl:text-xl font-bold text-gray-800 mb-6 xl:mb-3 2xl:mb-4 3xl:mb-6 flex items-center gap-3">
          <div className="w-8 h-8 xl:w-6 xl:h-6 2xl:w-7 2xl:h-7 3xl:w-8 3xl:h-8 rounded-xl bg-gradient-to-r from-emerald-500 to-teal-500 flex items-center justify-center">
            <span className="text-white text-lg xl:text-xs 2xl:text-sm 3xl:text-lg">📋</span>
          </div>
          Descripteurs disponibles
        </h3>
        <div className="space-y-4">
          {descripteurs.map((descripteur) => (
            <div
              key={descripteur.id}
              className="border-2 border-gray-200 rounded-2xl overflow-hidden transition-all duration-300 hover:border-blue-300 hover:shadow-md"
            >
              {/* Header du descripteur */}
              <div
                onClick={() => handleDescripteurClick(descripteur.nom)}
                className="flex items-center text-lg xl:text-xs 2xl:text-sm 3xl:text-lg justify-between p-4 xl:p-2 2xl:p-3 3xl:p-4 cursor-pointer
                 bg-gradient-to-r from-gray-50 to-slate-50
                  hover:from-blue-50 hover:to-sky-50 transition-all duration-300"
              >
                <div className="flex items-center gap-4 flex-1">
                  <h4 className="xl:text-base text-sm font-bold text-gray-800 leading-tight">
                    {descripteur.nom}
                  </h4>
                </div>
                <div className={`transform transition-transform duration-300 ${
                  expandedDescripteurs === descripteur.nom ? 'rotate-180' : ''
                }`}>
                  <ChevronDown className="w-6 h-6 text-blue-500" />
                </div>
              </div>

              {/* Savoirs-faires (collapsible) */}
              {showSavoirsForDescripteur && selectedDescripteur === descripteur.nom && (
                <div className="p-6 xl:p-3 2xl:p-4 3xl:p-6 bg-white border-t border-gray-100 animate-fadeInUp">
                  <div className="space-y-3">
                    {typeSavoir === 'bulletin_de_rentrée' && (
                      savoirs && savoirs.length > 0 ? (
                        savoirs.map((savoir) => (
                          <div key={savoir.id} className="xl:text-sm text-xs">
                            <NotificationOption
                              label={savoir.nom}
                              onChange={() => handleSavoirChange(savoir)}
                              checked={selectedSavoirs?.some((s) => s.id === savoir.id)}
                            />
                          </div>
                        ))
                      ) : (
                        <p className="text-center py-4 text-gray-400 text-sm">Aucun savoir-faire disponible</p>
                      )
                    )}

                    {typeSavoir === 'attendus' && (
                      attendus && attendus.length > 0 ? (
                        (() => {
                          const renderAtt = (attendu) => (
                            <div key={attendu.id} className="xl:text-sm text-xs">
                              <NotificationOption
                                label={attendu.description}
                                onChange={() => handleAttenduChange(attendu)}
                                checked={selectedAttendus?.some((a) => a.id === attendu.id)}
                              />
                            </div>
                          );
                          const { objectifs, automatismes } = partitionnerParRubrique(attendus);
                          if (automatismes.length === 0) return attendus.map(renderAtt);
                          const cleObjs = `${descripteur.nom}::objs`;
                          const cleAutos = `${descripteur.nom}::autos`;
                          const contientCoche = (liste) => liste.some(a => selectedAttendus?.some(sa => sa.id === a.id));
                          const objsOuverts = choixSections[cleObjs] !== undefined ? choixSections[cleObjs] : contientCoche(objectifs);
                          const autosOuverts = choixSections[cleAutos] !== undefined ? choixSections[cleAutos] : contientCoche(automatismes);
                          return (
                            <>
                              {objectifs.length > 0 ? (
                                <SeparateurRubrique rubrique="objectif" count={objectifs.length}
                                  ouvert={objsOuverts} onToggle={() => toggleSection(cleObjs, objsOuverts)} />
                              ) : null}
                              {objsOuverts ? objectifs.map(renderAtt) : null}
                              <SeparateurRubrique rubrique="automatisme" count={automatismes.length}
                                ouvert={autosOuverts} onToggle={() => toggleSection(cleAutos, autosOuverts)} />
                              {autosOuverts ? automatismes.map(renderAtt) : null}
                            </>
                          );
                        })()
                      ) : (
                        <p className="text-center py-4 text-gray-400 text-sm">Aucun attendu disponible</p>
                      )
                    )}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </>
    )}
  </div>
)}
</div>
        </>
        }

 {/* Résumé des sélections : visible même sans thème choisi (après un
     changement de niveau, les attendus cochés restent sous les yeux). */}
{(selectedSavoirs.length > 0 || selectedAttendus.length > 0) && (
  <div className="bg-gradient-to-r
   from-green-500 to-emerald-600 text-white p-6 xl:p-3 2xl:p-4 3xl:p-6 rounded-2xl mb-8 xl:mb-4 2xl:mb-6 3xl:mb-8 shadow-lg animate-fadeInUp">
      <div className="flex items-center gap-3 mb-4 xl:mb-2 2xl:mb-3 3xl:mb-4">
                <div className="w-8 h-8 xl:w-6 xl:h-6 2xl:w-7 2xl:h-7 3xl:w-8 3xl:h-8 bg-white/20 rounded-lg flex items-center justify-center">
                  <span className="text-lg xl:text-xs 2xl:text-sm 3xl:text-lg">📋</span>
                </div>
                <h3 className="text-xl xl:text-sm 2xl:text-base 3xl:text-xl font-bold">
                  Savoirs-faires sélectionnés: {selectedSavoirs.size}
                </h3>
              </div>
          <div className="flex flex-wrap xl:text-sm text-xs gap-3 overflow-auto max-h-[15vh]">
           
              {selectedSavoirs.map((selected) => (
                <div key={selected.id} style={{ minWidth: '40%' }} 
                className="flex items-center gap-2 bg-white/40 text-black/70 px-4 py-2 
                rounded-full backdrop-blur-sm">
                  <p className='p-1 max-h-52 leading-relaxed'> <MathText>{tronquerTexteMaths(selected.nom, 100).truncated}</MathText> </p>
                  <button type="button" onClick={() => handleSavoirChange(selected)}  className="w-5 h-5 bg-white/30 rounded-full flex items-center justify-center
                   hover:bg-white/50 transition-colors"
                    >
                      <span className="text-xs font-bold">×</span></button>
                </div>
              ))}
              {selectedAttendus.map((selected) => (
                <div key={selected.id} style={{ minWidth: '40%' }} className="flex items-center gap-2  bg-black/40 px-4 py-2 rounded-full backdrop-blur-sm">
                  <p className='p-1 max-h-52'> <MathText>{tronquerTexteMaths(selected.description, 100).truncated}</MathText> </p>
                  <button type="button" onClick={() => handleAttenduChange(selected)} 
                  className="w-5 h-5 bg-white/30 rounded-full flex items-center justify-center hover:bg-white/50 transition-colors"
                    >
                      <span className="text-xs font-bold">×</span>
                    </button>
                </div>
              ))}
            </div>
        
          </div>
        )}

   {/* Message de warning */}
{(selectedSavoirs.length=== 0 && selectedAttendus.length === 0)  &&
(
 <div className="mx-6 xl:mx-3 2xl:mx-4 3xl:mx-6 flex items-center gap-3 mb-6 xl:mb-3 2xl:mb-4 3xl:mb-6 p-4 xl:p-2 2xl:p-3 3xl:p-4 bg-gradient-to-r from-yellow-50 to-amber-50
  border-2 border-amber-200 rounded-xl ">
              <div className="w-6 h-6 rounded-full bg-amber-500 flex items-center 
              justify-center flex-shrink-0">
                <span className="text-white text-sm font-bold">!</span>
              </div>
              <span className="text-amber-700 text-sm font-semibold">
                Veuillez sélectionner au moins un savoir-faire pour continuer !
              </span>
            </div>)} 

          {/* Boutons d'action */}
          <div className="flex px-6 xl:px-3 2xl:px-4 3xl:px-6 justify-between items-center pb-8 xl:pb-4 2xl:pb-6 3xl:pb-8 pt-8 xl:pt-4 2xl:pt-6 3xl:pt-8 border-t border-gray-200">
            <button
              onClick={handlePrev}
              className="flex items-center gap-2 
              xl:text-xs 2xl:text-sm 3xl:text-lg text-sm px-8 xl:px-4 2xl:px-6 3xl:px-8 py-4 xl:py-2 2xl:py-3 3xl:py-4 bg-gradient-to-r from-orange-500 to-orange-600 text-white font-semibold rounded-xl transition-all duration-300 hover:scale-105 hover:shadow-xl uppercase tracking-wide"
            >
              <ChevronLeft className="w-5 h-5" />
              Retour
            </button>
            
            <button
              onClick={handleNext}
              disabled={selectedSavoirs.length === 0 && selectedAttendus.length ===0}
              className={`
                flex 
                xl:text-xs 2xl:text-sm 3xl:text-lg text-sm
                items-center gap-2 px-8 xl:px-4 2xl:px-6 3xl:px-8 py-4 xl:py-2 2xl:py-3 3xl:py-4 font-semibold rounded-xl transition-all duration-300 hover:scale-105 hover:shadow-xl uppercase tracking-wide
                ${selectedSavoirs.length > 0 || selectedAttendus.length >0
                  ? 'bg-gradient-to-r from-green-500 to-emerald-600 text-white' 
                  : 'bg-gradient-to-r from-gray-300 to-gray-400 text-gray-500 cursor-not-allowed'
                }
              `}
            >
              ✓ Suivant
              <ChevronRight className="w-5 h-5" />
            </button>
          </div>



</div>
    )
}

export default InfoSavoirs;